import { useMediaQuery } from '@mantine/hooks'
import Image from 'next/image'
import Link from 'next/link'

import styles from './footer_layout.module.scss'

export const FooterCopyright1st = [
  '상호명 : 멋쟁이사자처럼',
  '대표 : 나성영',
  'works@likelion.net',
  '사업자 번호 : 264-88-01106',
  '통신판매업 신고번호 : 2019-서울강남-00774',
]

export const FooterCopyright2rd = [
  '주소 : 서울 종로구 종로3길17, 광화문D타워 D1동 16층, 17층',
  'Copyright © 2025 멋쟁이사자처럼 All rights reserved.',
]

const Footer = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)')

  return (
    <div className="relative z-10 border-t bg-white px-4 py-6">
      <Image
        className="lg:my-2"
        src={'https://d35ai18pny966l.cloudfront.net/b2b/likelion_logo_black.svg'}
        width={isMobile ? 144 : 180}
        height={isMobile ? 16 : 20}
        alt="멋쟁이사자처럼"
      />
      <div className="mt-5 lg:mt-4">
        <ul className="flex flex-row items-center">
          <li>
            <Link
              href="https://likelion.notion.site/89ba1354b98d4825af14109aebdd3af9"
              target="_blank"
            >
              <p className="whitespace-pre-wrap py-2 text-xs font-medium text-label-normal">
                이용약관
              </p>
            </Link>
          </li>
          <li className="mx-2 h-1 w-1 rounded-full bg-trueGray-800"></li>
          <li>
            <Link
              href="https://likelion.notion.site/4d3c7ce22a724b3c99950e853dc7589b"
              target="_blank"
            >
              <p className="whitespace-pre-wrap py-2 text-xs font-medium text-label-normal">
                개인정보처리방침
              </p>
            </Link>
          </li>
        </ul>
        <div className="flex flex-col gap-y-0.5 lg:gap-y-1">
          <ul className="flex flex-row flex-wrap gap-y-0.5">
            {FooterCopyright1st.map(el => (
              <li
                key={`copyright_${el}`}
                className={`${styles.footer_copyright_li} relative mr-2 pr-2 text-xs text-label-neutral last-of-type:mr-0 last-of-type:pr-2`}
              >
                <span>{el}</span>
              </li>
            ))}
          </ul>
          <ul className="flex flex-row flex-wrap gap-x-2 gap-y-0.5">
            {FooterCopyright2rd.map(el => (
              <li key={`copyright_${el}`} className="text-xs text-label-neutral">
                <span>{el}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Footer
